

import React, { memo } from 'react';
import cx from 'classnames';

import { CARD_OVERLAY } from '../../styles/card';

import Favourite from '../../../../../Favourite';
import Actions from './OverlayActions';
import OverlayButton from './OverlayButton';
















const CardOverlay = ({ button, more, favourite }) =>
<div className={cx('card-overlay', CARD_OVERLAY)}>
    {Boolean(favourite) && <Favourite {...favourite} />}
    {Boolean(more) && <Actions {...more} />}
    {Boolean(button) && <OverlayButton {...button} />}
  </div>;


export default memo(CardOverlay);